module.exports = __webpack_public_path__ + "static/media/CultureHQ-Video-Studio-Icon.9ae416c9.png";